import { FhInputConfigInterface } from '../interfaces/fh-input-config-interface';
import { FormControl } from '@angular/forms';

export class FhInputConfigModel implements FhInputConfigInterface {
  type?: 'TEXT' | 'NUMBER' | 'INPUTMASK' | 'SWITCH' | 'TEXTAREA' | 'PASSWORD' | 'DROPDOWN' | 'DATE' | 'FILE' | 'MULTISELECT' | 'FORM_ARRAY' | 'FILE' = 'TEXT';
  control?: FormControl | undefined;
  rows? = '5';
  cols? = '30';
  bootstrapCol? = 'col-12';
  class? = '';
  labelClass? = '';
  inputMask? = '9999-999';
  placeholder?: any = '';
  numberMode? = 'currency';
  locale? = 'pt-PT';
  minFractionDigits? = 2;
  maxFractionDigits? = 2;
  suffix? = '';
  currency? = 'EUR';
  currencyDisplay? = 'symbol';
  label? = '';
  infoLabel? = '';
  idInputPassword?: any = '';
  passwordFeedback?: any = false;
  toggleMaskPassword?: any = true;
  readonly?: boolean = false;
  disabled?: boolean = false;
  id? = '';
  validators?: any;
  visible?: boolean = true;
  required?: boolean = false;
  allowHtml?: boolean = false;
  labelKey?: string = '';
  prefix?:string='';

  constructor(init?: Partial<FhInputConfigModel>) {
    Object.assign(this, init);
  }
}
